import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  // Label,
  Button,
  // Input,
  CardHeader,
  CardText,
  Label,
  Input,
  Badge,
  // Table,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import BootstrapTable from "react-bootstrap-table-next"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import SimpleBar from "simplebar-react"
import { useSelector, useDispatch } from "react-redux"
import * as emailAction from "../../store/ZW1haWxfdGVtcGxhdghj/actions"

import PropTypes from "prop-types"

// import { CSVExport } from "react-bootstrap-table2-toolkit"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"

import SimpleReactValidator from "simple-react-validator"
// import api from "helpers/Api"
import { ToastContainer, toast } from "react-toastify"
import { isEmpty } from "lodash"
import api from "helpers/Api"
import ButtonSpinner from "components/ButtonSpinner"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

const EmailTemplate = (props) => {
  const { searchBarStyle, formatterStyle } = props
  const { SearchBar } = Search

  //Reducer state maintenance
  const dispatch = useDispatch()
  const update = useSelector((specificstate) => specificstate.email)
  const [mailSettingDetails, setMailSettingDetails] = useState("")
  const { recordsMetaData = {}, records = [] } = update
  console.log(recordsMetaData, "recordsMetaData")
  console.log(records, "records")

  const shortCode = !isEmpty(recordsMetaData) ? recordsMetaData.codeOptions : ""
  useEffect(() => {
    dispatch(emailAction.loadRecordsMetaData())
    dispatch(emailAction.loadRecords())
    setEmailData({
      shortCode: shortCode,
    })
    api
      .post("get_from_mail_settings")
      .then((res) => {
        setMailSettingDetails(res.data.data)
        res.data
      })
      .catch((error) => Promise.reject(error))
  }, [1])
  console.log(shortCode, "shortCode")

  //Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  //modal
  const [openModal, setOpenModal] = useState(false)

  const [deleteModal, setDeleteModal] = useState(false)

  //Input state maintenance
  const [emailData, setEmailData] = useState({
    _id: "",
    settingType: [],
    title: "",
    subject: "",
    shortCode: "",
    type: [],
    message: "",
    templateName: "",
    attachment: [],
  })

  const [settingType, setSettingType] = useState([])
  const [emailType, setEmailType] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [emailRemoveId, setEmailRemoveId] = useState("")
  const [attachmentViewData, setAttachmentViewData] = useState("")

  console.log(attachmentViewData, "attachmentViewData")
  //Mail setting dropdown
  const settingTypeOptions =
    !isEmpty(mailSettingDetails) && mailSettingDetails.length > 0
      ? mailSettingDetails.map((data) => {
          return {
            label: data.fromMail,
            value: data.settingId,
            mailServiceId: data.mailServiceId,
            password: data.mailPassword,
            service: data.service,
          }
        })
      : []
  console.log(settingTypeOptions, "settingTypeOptions")

  //Type dropdown
  const emailTypeOptions = [
    {
      label: "Invitation Mail",
      value: "Invitation Mail",
    },
  ]
  //Status Update
  const [statusUpdateModal, setStatusUpdateModal] = useState(false)
  const [statusName, setStatusName] = useState("")
  console.log(statusName, "statusName")
  //Onchange
  const handleChange = (e) => {
    setEmailData({ ...emailData, [e.target.name]: e.target.value })
  }

  //Attachment changes
  const [attachmentModalFile, setAttachmentModalFile] = useState([])

  const handleEmailAttachment = async (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var leaveAttachmentValue = attachmentModalFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              leaveAttachmentValue.push(res.data.data)
              await setAttachmentModalFile(leaveAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
    }
  }

  //Rich text editor
  // const [ quill, quillRef ] = useQuill()
  const [emailMessage, setEmailMessage] = useState({
    editorHtml: "",
    theme: "snow",
  })

  const handleEmailChange = (html) => {
    setEmailMessage({ editorHtml: html })
  }

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [2, 4, 6, 8, 10, 12, 14, 16, 18, 19, 24, 32, 38, 64, 72] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        {
          color: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
      [
        {
          background: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
    ],
  }

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ]

  // const handleThemeChange = (newTheme) => {
  //   if (newTheme === "core") newTheme = null
  //   setEmailMessage({ theme: newTheme })
  // }

  console.log(emailMessage, "this is quill editor")
  //Email Data tables
  let slNo = 0
  const emailDataTable =
    !isEmpty(records) && records.length > 0
      ? records.map((data) => {
          slNo = slNo + 1

          const attachmentValue = !isEmpty(data.attachment)
            ? data.attachment.map((data) => data)
            : ""
          // const attachmentViewValue = !isEmpty(data.attachment) && data.attachment.length > 0
          //   ? data.attachment[0]
          //   : ""

          const settingName =
            !isEmpty(settingTypeOptions) &&
            settingTypeOptions &&
            !isEmpty(data.SettingId) &&
            settingTypeOptions.length > 0
              ? settingTypeOptions.find(
                  (setting) => setting.value === data.SettingId
                ).label
              : "--"

          return {
            _id: !isEmpty(data) ? data._id : "",
            sNo: slNo,
            action: (
              <div style={{ display: "flex" }}>
                <Button
                  type="submit"
                  onClick={() => {
                    editEmailTemplate(data)
                    setOpenModal(true)
                    setAttachmentViewData(attachmentValue)
                  }}
                  style={{ fontSize: "10px" }}
                  className="btn btn-success buttons"
                >
                  <i
                    className="fas fa-pencil-alt icon-btn"
                    style={{ fontSize: "11px" }}
                  ></i>
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    setDeleteModal(true)
                    setEmailRemoveId(data._id)
                  }}
                  style={{ fontSize: "10px", marginLeft: "10px" }}
                  className="btn btn-danger buttons"
                >
                  <i
                    className="fas fa-trash-alt icon-btn"
                    style={{ fontSize: "11px" }}
                  ></i>
                </Button>
              </div>
            ),
            settingType: data.settingType,
            fromMailService: data.fromMailService,
            settingName: settingName,
            title: data.title,
            subject: data.subject,
            shortCode: data.shortCode,
            type: data.type,
            message: !isEmpty(data.message) ? data.message : "",
            templateName: data.templateName,
            attachment: attachmentValue,
            status: data.status,
          }
        })
      : []

  //Select Rows
  let [selectedRows, setSelectedRows] = useState([])

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      selectedRows.push(row)
    } else {
      selectedRows = selectedRows.filter(
        (_) => _._id.toString() !== row._id.toString()
      )
    }
    setSelectedRows(selectedRows)
    return true
  }

  const handleOnSelectAll = (isSelect, rows) => {
    var ar = []
    if (isSelect) {
      ar = rows
    } else {
      ar = []
      setSelectedRows([])
    }

    setSelectedRows(ar)
    return true
  }

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    clickToEdit: false,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    selected: selectedRows.map((_) => _._id),
  }
  //table columns

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
      csvExport: false,
    },

    {
      dataField: "settingName",
      text: "Setting Type",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "subject",
      text: "Subject",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "shortCode",
      text: "Short Code",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "templateName",
      text: "Template Name",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "attachment",
      text: "Attachment",
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => window.open(row.attachment, "_blank")}
            style={{ textDecoration: "underline", color: "#E40D8C" }}
          >
            View
          </div>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            pill
            // color={row.status === 2 ? "danger" : "success"}
          >
            {row.status === 2 ? "Inactive" : "Active"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
  ]
  //download feature in data table
  // const { ExportCSVButton } = CSVExport

  //Add Email template
  const addEmailTemplate = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const record = {
        SettingId: settingType.value,
        mailServiceId: settingType.mailServiceId,
        // SettingId: "64d73d93ed8bbf197d8bc42c",
        title: emailData.title,
        subject: emailData.subject,
        shortCode: emailData.shortCode,
        type: emailType.value,
        // type: "Invitation Mail",
        message: emailMessage.editorHtml,
        templateName: emailData.templateName,
        attachment: attachmentModalFile,
      }
      console.log(record, "records in add")
      dispatch(emailAction.createRecord(record))
      setTimeout(() => {
        dispatch(emailAction.loadRecords())
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        })
        setOpenModal(false)
      }, 1500)
      setIsEdit(false)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setOpenModal(true)
    }
  }

  //Edit Email template
  const editEmailTemplate = (data) => {
    console.log(data, "data")
    setEmailData({
      _id: data._id,
      title: data.title,
      subject: data.subject,
      settingType: data.settingType,
      shortCode: shortCode,
      message: data.message,
      templateName: data.templateName,
    })
    setEmailMessage({
      editorHtml: data.message,
    })
    setSettingType({ label: data.fromMailService, value: data.SettingId })
    setEmailType({ label: data.type, value: data.type })
    // setAttachmentModalFile(data.attachment)
    setIsEdit(true)
  }

  //Update Email template
  const updateEmailTemplate = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const record = {
        _id: emailData._id,
        SettingId: settingType.value,
        mailServiceId: settingType.mailServiceId,
        // SettingId: "64d73d93ed8bbf197d8bc42c",
        title: emailData.title,
        subject: emailData.subject,
        shortCode: emailData.shortCode,
        type: emailType.value,
        // type: "Invitation Mail",
        message: emailMessage.editorHtml,
        templateName: emailData.templateName,
        attachment: attachmentModalFile,
      }
      console.log(record, "record")
      dispatch(emailAction.updateRecord(record))
      setTimeout(() => {
        dispatch(emailAction.loadRecords())
        toast.success("Records Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        })
        setOpenModal(false)
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setOpenModal(true)
    }
  }

  //Delete Email template
  const deleteEmailTemplate = () => {
    dispatch(emailAction.deleteRecord(emailRemoveId))
    setTimeout(() => {
      dispatch(emailAction.loadRecords())
      toast.success("Records Deleted Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      })
      setDeleteModal(false)
    }, 1500)
    // }
  }

  //Update Status
  const statusUpdate = () => {
    const record = {
      emailId: selectedRows.map((data) => data._id),
      status: statusName === "3" ? 3 : statusName === "2" ? 2 : 1,
    }
    dispatch(emailAction.updateStatus(record))
    console.log(record, "record in status update")
    setTimeout(() => {
      dispatch(emailAction.loadRecords())
      toast.success("Records Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      })
      setSelectedRows([])
      setStatusUpdateModal(false)
    }, 1500)
  }
  console.log(selectedRows, "selected rows")

  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: records.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  //Page title section
  const title = "Email Template"
  const formTitle = "Manage Email Template"

  //Clear data
  const clearData = () => {
    setOpenModal(true)
    setEmailData({
      shortCode: shortCode,
      _id: "",
      settingType: [],
      title: "",
      subject: "",
      type: [],
      message: "",
      templateName: "",
      attachment: [],
    })
    setIsEdit(false)
    setEmailMessage({
      editorHtml: "",
    })
    setSettingType([])
    setEmailType([])
    setAttachmentModalFile([])
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid></Container>
      <Breadcrumbs title={"Master"} breadcrumbItem={title} />

      <Row>
        <Col>
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(options)}
                keyField="_id"
                columns={columns}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="_id"
                    data={emailDataTable}
                    columns={columns}
                    search
                    exportCSV
                  >
                    {(props) => (
                      <div>
                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                          <Row className="d-flex flex-row  ">
                            <Col lg="12" md="12" sm="12" xs="12">
                              <div
                                className="filter-buttons"
                                style={{ float: "right" }}
                              >
                                <Button
                                  style={{
                                    backgroundColor: "#E40D8C",
                                    color: "white",
                                    border: "none",
                                    // marginTop: "-35px",
                                  }}
                                  onClick={() => {
                                    clearData()
                                  }}
                                >
                                  Add Email Template
                                </Button>
                              </div>
                            </Col>

                            <Col className="mb-3 mt-3" md="4">
                              <div className="d-flex flex-row ">
                                <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                  <div
                                    className="position-relative mt-7"
                                    style={searchBarStyle || null}
                                  >
                                    <SearchBar {...props.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </div>{" "}
                            </Col>

                            {/* <Col>
                              <ExportCSVButton
                                className="border float-right mx-10"
                                style={{
                                  float: "right",
                                  backgroundColor: "#e40d8c",
                                  color: "#ffffff",
                                }}
                                {...props.csvProps}
                              >
                                Download{" "}
                              </ExportCSVButton>{" "}
                            </Col> */}
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <BootstrapTable
                                {...props.baseProps}
                                responsive
                                striped={true}
                                bordered={true}
                                keyField="_id"
                                columns={columns}
                                selectRow={selectRow}
                                {...paginationTableProps}
                              />
                            </Col>
                          </Row>
                          <Row
                            style={{ marginTop: "5px" }}
                            className="align-items-md-center mt-30"
                          >
                            <Col className="inner-custom-pagination d-flex">
                              <div className="d-inline d-flex flex-row">
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginTop: "8px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <PaginationTotalStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </div>
                              <div
                                className="text-md-right ms-auto"
                                style={{ zIndex: 0 }}
                              >
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex flex-row mt-2">
                              <Button
                                className="btn btn-danger"
                                onClick={() => {
                                  setStatusUpdateModal(true)
                                  setStatusName("3")
                                  setTimeout(() => {
                                    setBtnLoader(false)
                                  }, 1500)
                                }}
                              >
                                {btnLoader ? <ButtonSpinner /> : "Delete"}
                              </Button>
                              <Button
                                className="btn btn-success mx-3"
                                onClick={() => {
                                  setStatusUpdateModal(true)
                                  setStatusName("1")
                                  setTimeout(() => {
                                    setBtnLoader(false)
                                  }, 1500)
                                }}
                              >
                                {btnLoader ? <ButtonSpinner /> : "Active"}
                              </Button>
                              <Button
                                className="btn btn-primary mx-1"
                                style={{
                                  backgroundColor: "#556ee6",
                                  color: "white",
                                  border: "none",
                                }}
                                onClick={() => {
                                  setStatusUpdateModal(true)
                                  setStatusName("2")
                                  setTimeout(() => {
                                    setBtnLoader(false)
                                  }, 1500)
                                }}
                              >
                                {btnLoader ? <ButtonSpinner /> : "Inactive"}
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {openModal && (
        <Row>
          <Col lg="12" md="12" sm="12" xs="12" className="simplebar-background">
            <div className="simple-right-bar" style={formatterStyle}>
              <SimpleBar>
                <div className="modal-header simple-modal-header">
                  <h5
                    style={{ textTransform: "uppercase" }}
                    className="mx-2 modal-title mt-0"
                    id="myModalLabel"
                  >
                    {formTitle}
                  </h5>
                  <button
                    type="button"
                    onClick={() => setOpenModal(false)}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times</span>
                  </button>
                </div>
                <div className="modal-body simple-modal-body">
                  <Row className="simple-form-row">
                    <Card>
                      <CardHeader className="h5 bg-transparent card-input-header text-uppercase">
                        {isEdit
                          ? "UPDATE EMAIL TEMPLATE"
                          : "ADD EMAIL TEMPLATE"}
                      </CardHeader>
                      <CardBody>
                        <CardText
                          style={{
                            display: "flex",
                            marginRight: "-15px",
                            flexWrap: "wrap",
                            marginBottom: "6px",
                          }}
                        >
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Code"}
                              >
                                {"Setting Type"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="settingType"
                              value={settingType}
                              onChange={(e) => setSettingType(e)}
                              options={settingTypeOptions}
                              placeholder="Select Setting Type"
                            />

                            {simpleValidator.current.message(
                              "settingType",
                              settingType,
                              "required"
                            )}
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Code"}
                              >
                                {"Title"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>

                            <Input
                              type="text"
                              name="title"
                              value={emailData.title}
                              onChange={(e) => handleChange(e)}
                              placeholder="Enter Title"
                            />

                            {simpleValidator.current.message(
                              "title",
                              emailData.title,
                              "required"
                            )}
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Name"}
                              >
                                {"Subject"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              name="subject"
                              value={emailData.subject}
                              onChange={(e) => handleChange(e)}
                              placeholder="Enter Subject"
                            />

                            {simpleValidator.current.message(
                              "subject",
                              emailData.subject,
                              "required"
                            )}
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Name"}
                              >
                                {"Short Code"}
                                {/* <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="text"
                              name="shortCode"
                              value={emailData.shortCode}
                              disabled
                              onChange={(e) => handleChange(e)}
                              placeholder="Enter Short Code"
                            />
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Name"}
                              >
                                {"Type"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>
                            <Select
                              name="emailType"
                              value={emailType}
                              onChange={(e) => setEmailType(e)}
                              placeholder="Select Type"
                              options={emailTypeOptions}
                            />
                            {simpleValidator.current.message(
                              "emailType",
                              emailType,
                              "required"
                            )}
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Name"}
                              >
                                {"Template Name"}
                                <span className="required mx-2">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              name="templateName"
                              value={emailData.templateName}
                              onChange={(e) => handleChange(e)}
                              placeholder="Enter Template Name"
                            />
                            {simpleValidator.current.message(
                              "templateName",
                              emailData.templateName,
                              "required"
                            )}
                          </Col>
                          <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"Freelancer Name"}
                              >
                                {"Message"}
                                <span className="required mx-1">*</span>
                              </Label>
                            </div>
                            <div>
                              <ReactQuill
                                theme={emailMessage.theme}
                                value={emailMessage.editorHtml}
                                onChange={handleEmailChange}
                                modules={modules}
                                //  style={height: ""}
                                style={{ height: "110px" }}
                                // className="rich-editor-style"
                                bounds={".rich-editor-style"}
                                formats={formats}
                                placeholder="Write something..."
                              />
                            </div>
                          </Col>

                          <Col
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            className="d-flex flex-column"
                            style={{ marginTop: "80px" }}
                          >
                            {simpleValidator.current.message(
                              "editorHtml",
                              emailMessage.editorHtml,
                              "required"
                            )}{" "}
                            <Label className="employee-label">
                              Attachment File
                            </Label>
                            <Input
                              type="file"
                              name="attachmentModalFile"
                              // value={attachmentModalFile}
                              multiple
                              onChange={(e) => handleEmailAttachment(e)}
                            />
                            {isEdit && !isEmpty(attachmentViewData) ? (
                              <div
                                style={{
                                  textDecoration: "underline",
                                  color: "#E408DC",
                                  marginTop: "4px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  window.open(attachmentViewData, "_blank")
                                }
                              >
                                View Attachment
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                        </CardText>
                      </CardBody>
                    </Card>
                  </Row>
                </div>
                <div className="modal-footer simple-modal-footer mt-2">
                  <div>
                    <Button
                      type="button"
                      onClick={() => {
                        setTimeout(() => {
                          setOpenModal(false)
                        }, 500)
                      }}
                      className="btn btn-danger buttons"
                    >
                      Cancel
                    </Button>
                    {isEdit ? (
                      <Button
                        type="submit"
                        onClick={(e) => {
                          updateEmailTemplate(e)
                        }}
                        style={{ marginLeft: "10px" }}
                        className="btn btn-success buttons"
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        onClick={(e) => {
                          addEmailTemplate(e)
                        }}
                        style={{ marginLeft: "10px" }}
                        className="btn btn-success buttons"
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                </div>
              </SimpleBar>
            </div>
          </Col>
        </Row>
      )}

      {deleteModal && (
        <Modal show={deleteModal} size="md">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              minHeight: "65px",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            {"Delete Email Template"}
          </Modal.Header>
          <Modal.Body>Do you want To Delete the Email Template?</Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                type="submit"
                onClick={() => {
                  setDeleteModal(false)
                }}
                className="btn btn-danger buttons"
              >
                {" "}
                No
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  deleteEmailTemplate()
                }}
                style={{ marginLeft: "10px" }}
                className="btn btn-success buttons"
              >
                {" "}
                Yes
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {/* //Status Update Modal */}
      {statusUpdateModal && (
        <Modal show={statusUpdateModal} size="md">
          <Modal.Header>
            <div className="d-flex flex-row justify-content-between">
              <h4>Confirm</h4>
              <button
                type="button"
                onClick={() => setStatusUpdateModal(false)}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times</span>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            Do you want to
            {statusName === "3"
              ? " delete"
              : statusName === "2"
              ? " inactive"
              : " active"}{" "}
            the selected rows?
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="submit"
                onClick={() => {
                  setStatusUpdateModal(false)
                  setSelectedRows([])
                }}
                style={{
                  cursor: "pointer",
                  background: "#dbdadb",
                  padding: "10px",
                  border: "none",
                  borderRadius: "2px",
                }}
                className="modal-close-btn"
              >
                {" "}
                <span style={{ color: "black" }}>Close</span>
              </button>
              <Button
                type="submit"
                onClick={() => {
                  statusUpdate()
                }}
                style={{
                  marginLeft: "10px",
                  backgroundColor: "#E40D8C",
                  padding: "10px",
                  border: "none",
                }}
                className="btn btn-success buttons"
              >
                {" "}
                Confirm
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

EmailTemplate.propTypes = {
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  formatterStyle: PropTypes.object,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmailTemplate)
)
